module.exports = __webpack_public_path__ + "img/ad3_img.2539e1d6.png";